import React, { useState, useReducer } from 'react';
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import '../style/Home.css';
import { Container } from 'react-bootstrap';
import { apiFetchJson } from '../api';



const formReducer = (state, event) => {
    if (event.reset) {
        return {
            dbName: state.dbName,
            firstname: '',
            surname: '',
            password: Math.random().toString(36).slice(2, 10),
            email: '',
        }
    }
    return {
        ...state,
        [event.name]: event.value
    }
}

const formReducer2 = (state, event) => {
    if (event.reset) {
        return {
            dbName: state.dbName,
            jsonUpload: undefined,
        }
    }
    return {
        ...state,
        [event.name]: event.value
    }
}


const LoadToDB = ({ dbName }) => {

    const [formData, setFormData] = useReducer(formReducer, { dbName: dbName, password: Math.random().toString(36).slice(2, 10) });
    const [formData2, setFormData2] = useReducer(formReducer2, {
        dbName: dbName,
        jsonUpload: undefined
    });
    const [submitting, setSubmitting] = useState(false);



    const handleSubmit = event => {
        event.preventDefault();
        setSubmitting(true);

        console.log('submiting LoadToDB data:');
        apiFetchJson('/api/submitDBInsert', {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then(res => console.log(res))
            .then(() => {
                setSubmitting(false);
                setFormData({ reset: true })
            })
            .catch(error => console.log(error))
    }
    const handleSubmit2 = event => {
        event.preventDefault();
        setSubmitting(true);

        let input = document.getElementById('jsonUpload');
        const body = new FormData();
        body.append('file', input.files[0]);
        body.append('dbName', formData2.dbName);

        console.log('submiting LoadToDB via json:');
        apiFetchJson('/api/submitDBInsertViaJSON', {
            method: 'POST',
            body: body,
        })
            .then(res => console.log(res))
            .then(() => {
                setSubmitting(false);
                setFormData2({ reset: true })
            })
            .catch(error => console.log(error))
    }

    const handleChange = event => {
        setFormData({
            name: event.target.name,
            value: event.target.value,
        })
    }
    const handleChange2 = event => {
        setFormData2({
            name: event.target.name,
            value: event.target.value,
        })
    }



    return (
        <Container className="loadform">
            <h1>Add new {dbName} entry</h1>
            {submitting &&
                <div>
                    You are submitting the following:
                    <ul>
                        {Object.entries(formData).map(([name, value]) => (
                            <li key={name}><strong>{name}</strong>: {value.toString()}</li>
                        ))}
                    </ul>
                </div>
            }

            <div className="row">
                <div className="col-lg-5 border border-dark mx-1">
                    <Form onSubmit={handleSubmit} disabled={submitting}>
                        <Form.Group >
                            <Form.Label>
                                Database
                                <Form.Control type="textarea" name="dbName" placeholder={formData.dbName || ''} readOnly />
                            </Form.Label>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>
                                FirstName
                                <Form.Control type="textarea" name="firstname" onChange={handleChange} value={formData.firstname || ''} />
                            </Form.Label>
                            <Form.Label className="mx-3">
                                Surname
                                <Form.Control type="textarea" name="surname" onChange={handleChange} value={formData.surname || ''} />
                            </Form.Label>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>
                                Email
                                <Form.Control type="email" name="email" onChange={handleChange} value={formData.email || ''} />
                            </Form.Label>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>
                                Password (auto generated - user will be asked to change on first login)
                                <Form.Control type="textarea" name="password" onChange={handleChange} value={formData.password || ''} />
                            </Form.Label>
                        </Form.Group>
                        <Button type="submit" disabled={submitting}>
                            Submit
                        </Button>
                    </Form>
                </div>
                <div className="col-lg-5 border border-dark mx-1">

                    <Form onSubmit={handleSubmit2} disabled={submitting} encType='multiprt/form-data'>
                        <Form.Group >
                            <Form.Label>
                                Database
                                <Form.Control type="textarea" name="dbName" placeholder={formData2.dbName || ''} readOnly />
                            </Form.Label>
                            <Form.Label>
                                Upload via json
                                <Form.Control type="file" id="jsonUpload" name="jsonUpload" value={formData2.jsonUpload || ''} onChange={handleChange2} />
                            </Form.Label>
                        </Form.Group>
                        <Button type="submit" >
                            Submit
                        </Button>
                    </Form>
                </div>
            </div>
        </Container>
    )
}

export default LoadToDB;